import React from 'react';

import { useSuperHubStore } from '@core/store';

import EmptyState from '@routes/SuperHub/components/EmptyState';

/**
 * Renders the empty state for the Reference section when no API definition has
 * yet been created.
 */
export default function EmptyReference() {
  const isSuperHubAdmin = useSuperHubStore(s => s.user.role === 'admin');

  return <EmptyState action={isSuperHubAdmin ? '/update/reference' : undefined} section="reference" />;
}
